<template>
  <div id="app">
    <NavHeader v-if="!hideMainLayout" />
    <router-view></router-view>
    <FooterComponent v-if="!hideMainLayout" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import NavHeader from "@/components/NavHeader.vue";
import FooterComponent from "@/components/FooterComponent.vue";

const route = useRoute();
const hideMainLayout = computed(() => route.meta?.hideMainLayout === true);
</script>

<style>
:root {
  --primary-color: #f5bb44;
  --primary-dark: #f4a834;
  --primary-light: #fff9ef;
  --secondary-color: #f4a834;
  --bg-color: #f8f9fa;
  --text-primary: #2c3e50;
  --text-secondary: #666;
  --border-color: rgba(245, 187, 68, 0.15);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  /* line-height: 1.6; */
  color: var(--text-primary);
}
p {
  margin: 0;
  /* line-height: 0 !important; */
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 全局按钮样式 */
.btn {
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn.primary {
  background: linear-gradient(
    135deg,
    var(--primary-color),
    var(--primary-dark)
  );
  color: white;
}

.btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 187, 68, 0.3);
}
</style>
